import React from 'react';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import SwiperCarousel from '../../../../baseComponents/gui/carousel/Carousel';
import Image from '../Image/Image';
import ElfImage from '../Image/ElfImage';
import { settings } from '../../../../../constants/carousel-settings';
import content from '../../constants/content';
import { useWishes } from '../../../../../redux/reducer/content';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import classNames from 'classnames';

const { closeButton, navigation } = content;

export default function Carousel({ isHiddenWishCard }) {
  const { images, data, step } = useWishes();
  const callbacks = useApplicationCallbacks();
  const step1Elves = [data?.image?.elf1, data?.image?.elf2, data?.image?.elf3].map((image, index) => ({
    id: index + 1,
    image,
  }));

  return (
    isHiddenWishCard && (
      <>
        <CustomButton {...closeButton} />
        <div className={'wish__content-gallery'}>
          {step === 0 && (
            <SwiperCarousel
              key='wish-backgrounds'
              settings={{ ...settings.wishElf, onInit: callbacks.setWishSwiper }}
              item={Image}
              itemsData={images}
            />
          )}
          {step === 1 && step1Elves.some(({ image }) => image) && (
            <SwiperCarousel
              key='wish-elves'
              settings={{ ...settings.wishElf, onInit: callbacks.setWishElfSwiper }}
              item={ElfImage}
              itemsData={step1Elves}
            />
          )}
          <div className={'wish__content-navigation'}>
            {navigation.map(({ id, className }) => (
              <CustomButton
                key={id}
                className={classNames(className, `wish__content-nav wish__content-nav_${id}`)}
                icon={`wish/${id}`}
              />
            ))}
          </div>
          <div className={'wish__content-pagination'} />
        </div>
      </>
    )
  );
}
